import React, { useState, useRef, useEffect } from "react";
import { useLanguage } from "@/i18n";
import { KeenIcon } from "@/components";
import { I18N_LANGUAGES } from "@/i18n/config";
import clsx from "clsx";

const LanguageSwitcherLandingPage = () => {
  const { currentLanguage, changeLanguage, isRTL } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  if (!currentLanguage) {
    return null;
  }

  const handleLanguage = (lang) => {
    changeLanguage(lang);
    setIsOpen(false);
  };

  return (
    <div className="relative" ref={dropdownRef}>
      {/* Button trigger */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className=" flex items-center border border-[#50b553] rounded-[11px] shadow-md hover:bg-primary-2 transition-colors md:p-0 md:text-xs text-xs md:h-auto bg-[#9DFFA033]"
        style={{ fontFamily: "Lexend Deca, sans-serif" }}
      >
        <div className=" px-8 py-2 flex items-center justify-center gap-1.5 rounded-md text-[#50b553] font-medium shrink-0 md:text-sm w-full text-xs cursor-pointer hover:text-white ">
          {currentLanguage.label}
          <img
            src={currentLanguage.flag}
            className="inline-block md:w-3.5 md:h-3.5 w-6 h-6 rounded-full"
            alt={currentLanguage.label}
          />
        </div>
      </button>

      {/* Dropdown menu */}
      {isOpen && (
        <div
          className={clsx(
            "absolute left-1/2 transform -translate-x-1/2 mt-2 bg-transparent shadow-lg z-10  w-40",
            isRTL() ? "left-0" : "right-0"
          )}
        >
          {I18N_LANGUAGES.map((lang, index) => (
            <button
              key={index}
              onClick={() => handleLanguage(lang)}
              className={clsx(
                "flex items-center gap-3 w-full px-3 py-2 hover:bg-[#9dffa033] border border-[#9dffa033] mt-2 transition-colors rounded-[11px]",
                currentLanguage.code === lang.code
                  ? "text-[#50b553]"
                  : "text-gray-700"
              )}
            >
              <img
                src={lang.flag}
                className="inline-block w-4 h-4 rounded-full"
                alt={lang.label}
              />
              <span className="flex-grow text-left">{lang.label}</span>
              {currentLanguage.code === lang.code && (
                <KeenIcon
                  icon="check-circle"
                  style="solid"
                  className="text-white text-base flex-shrink-0"
                />
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcherLandingPage;
